// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const HttpRequestBody = {
    inlinedRequestBody: (value) => {
        return Object.assign(Object.assign({}, value), { type: "inlinedRequestBody", _visit: function (visitor) {
                return FernIr.HttpRequestBody._visit(this, visitor);
            } });
    },
    reference: (value) => {
        return Object.assign(Object.assign({}, value), { type: "reference", _visit: function (visitor) {
                return FernIr.HttpRequestBody._visit(this, visitor);
            } });
    },
    fileUpload: (value) => {
        return Object.assign(Object.assign({}, value), { type: "fileUpload", _visit: function (visitor) {
                return FernIr.HttpRequestBody._visit(this, visitor);
            } });
    },
    bytes: (value) => {
        return Object.assign(Object.assign({}, value), { type: "bytes", _visit: function (visitor) {
                return FernIr.HttpRequestBody._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "inlinedRequestBody":
                return visitor.inlinedRequestBody(value);
            case "reference":
                return visitor.reference(value);
            case "fileUpload":
                return visitor.fileUpload(value);
            case "bytes":
                return visitor.bytes(value);
            default:
                return visitor._other(value);
        }
    },
};
